import React from "react"
import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell";

// const debug = "FieldAttachmentsTotal_TableCell"
const debug = false

export default function FieldAttachmentsTotal_TableCell(props:FieldTableCellProps) {


    const hasValue = !!(props.listItem.calculatedAttachments.total && props.listItem.calculatedAttachments.total>0)

    return (

        <div className="cell-flex ui5-txt-less-important-small flex-row-center-center" style={getTableCellStyle(props)}>
            {hasValue &&
                <>
                    <div className="ui5-ico-13 i5-attachment m-r-5 flex-row-center-center min-w-15"></div>
                    {props.listItem.calculatedAttachments.total}
                </>
            }
        </div>

    )

}



